import { Icon, Avatar, Modal } from "@components/index";
import DeleteUser from "./components/DeleteUser";
import { useUserListRenderData } from "./userListRenderData";

import "./index.scss";

const UserListRender = ({ userList, onEditUser }) => {
  const {
    onDeleteUser,
    showDeleteUserDrawer,
    setShowDeleteUserDrawer,
    deleteUserDetails,
    confirmDeleteUser,
  } = useUserListRenderData();

  return (
    <div className="user-list-container">
      {userList.map((user) => (
        <div className="user-card" key={user.id}>
          <div className="user-info">
            <Avatar nameInitials={user.name} />

            <div className="user-details">
              <h3 className="user-name">{user.name}</h3>
              <p className="user-email">{user.email}</p>
              <p className="user-phone">{user.phoneNumber}</p>

              <div className="user-badges">
                {user.role && <span className="user-role">{user.role}</span>}
                {user.status && (
                  <span className={`user-status user-status--${user.status}`}>
                    {user.status}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="user-actions">
            <button
              className="action-btn edit-btn"
              onClick={() => onEditUser(user)}
              title="Edit User"
            >
              <Icon iconName="edit" width={16} height={16} />
            </button>

            <button
              className="action-btn delete-btn"
              onClick={() => onDeleteUser(user)}
              title="Delete User"
            >
              <Icon iconName="delete" width={16} height={16} />
            </button>
          </div>
        </div>
      ))}

      {showDeleteUserDrawer && (
        <Modal
          isOpen={showDeleteUserDrawer}
          onClose={() => setShowDeleteUserDrawer(false)}
          className="my-custom-modal"
          closeOnOutsideClick={true}
        >
          <DeleteUser
            deleteUserDetails={deleteUserDetails}
            handleDeleteCancel={() => setShowDeleteUserDrawer(false)}
            handleDeleteConfirm={confirmDeleteUser}
          />
        </Modal>
      )}
    </div>
  );
};

export default UserListRender;
